import {
  BedIcon,
  CrownIcon,
  HeartIcon,
  HeartRangeMetricIcon,
  HrvIcon,
  MeditationIcon,
} from '@jouzen/ecom-components';
import type { SVGIconComponent } from 'types/svgr';

import type { LandingPageMembershipTabData } from '@/app/components/LandingPage/LandingPageMembershipTabContent/LandingPageMembershipTabContentCard';

//TODO: GROW-1607 clean up Gen3 clean up
export const popMembershipTabs: LandingPageMembershipTabData[] = [
  {
    backgroundColor: 'blue',
    Icon: BedIcon as SVGIconComponent,
    id: 'sleep',
    tab: {
      label: 'pop_membership_sleep_tab_title',
    },
    tabPanel: {
      cards: [
        {
          copy: 'pop_membership_sleep_score_copy',
          image: {
            alt: 'pop_membership_sleep_score_ui_alt',
            src: 'pop_membership_sleep_score_ui_src',
          },
          title: 'pop_membership_sleep_score_title',
        },
        {
          copy: 'pop_membership_sleep_stages_copy',
          image: {
            alt: 'pop_membership_sleep_stages_ui_alt',
            src: 'pop_membership_sleep_stages_ui_src',
          },
          title: 'pop_membership_sleep_stages_title',
        },
        {
          copy: 'pop_membership_blood_oxygen_sensing_copy',
          image: {
            alt: 'pop_membership_blood_oxygen_sensing_ui_alt',
            src: 'pop_membership_blood_oxygen_sensing_ui_src',
          },
          title: 'pop_membership_blood_oxygen_sensing_title',
        },
        {
          copy: 'pop_membership_bedtime_guidance_copy',
          image: {
            alt: 'pop_membership_bedtime_guidance_ui_alt',
            src: 'pop_membership_bedtime_guidance_ui_src',
          },
          title: 'pop_membership_bedtime_guidance_title',
        },
      ],
      featuredImage: {
        backgroundImage: {
          alt: 'pop_membership_sleep_featured_img_alt',
          src: 'blue-sky/pop/sleep_featured',
        },
      },
    },
  },
  {
    backgroundColor: 'blue',
    Icon: HrvIcon as SVGIconComponent,
    id: 'activity_and_fitness',
    tab: {
      label: 'pop_membership_activity_and_fitness_tab_title',
    },
    tabPanel: {
      cards: [
        {
          copy: 'pop_membership_activity_score_copy',
          image: {
            alt: 'pop_membership_activity_score_ui_alt',
            src: 'pop_membership_activity_score_ui_src',
          },
          title: 'pop_membership_activity_score_title',
        },
        {
          copy: 'pop_membership_workout_heart_rate_copy',
          image: {
            alt: 'pop_membership_workout_heart_rate_ui_alt',
            src: 'pop_membership_workout_heart_rate_ui_src',
          },
          title: 'pop_membership_workout_heart_rate_title',
        },
        {
          copy: 'pop_membership_automatic_activity_detection_copy',
          image: {
            alt: 'pop_membership_automatic_activity_detection_ui_alt',
            src: 'pop_membership_automatic_activity_detection_ui_src',
          },
          title: 'pop_membership_automatic_activity_detection_title',
        },
      ],
      featuredImage: {
        backgroundImage: {
          alt: 'pop_membership_activity_and_fitness_featured_img_alt',
          src: 'blue-sky/pop/activity_and_fitness_featured',
        },
      },
    },
  },
  {
    backgroundColor: 'blue',
    Icon: CrownIcon as SVGIconComponent,
    id: 'readiness',
    tab: {
      label: 'pop_membership_readiness_tab_title',
    },
    tabPanel: {
      cards: [
        {
          copy: 'pop_membership_readiness_score_copy',
          image: {
            alt: 'pop_membership_readiness_score_ui_alt',
            src: 'pop_membership_readiness_score_ui_src',
          },
          title: 'pop_membership_readiness_score_title',
        },
        {
          copy: 'pop_membership_illness_detection_copy',
          image: {
            alt: 'pop_membership_illness_detection_ui_alt',
            src: 'pop_membership_illness_detection_ui_src',
          },
          title: 'pop_membership_illness_detection_title',
        },
      ],
      featuredImage: {
        backgroundImage: {
          alt: 'pop_membership_readiness_featured_img_alt',
          src: 'blue-sky/pop/readiness_featured',
        },
      },
    },
  },
  {
    backgroundColor: 'blue',
    Icon: HeartRangeMetricIcon as SVGIconComponent,
    id: 'stress',
    tab: {
      label: 'pop_membership_stress_tab_title',
    },
    tabPanel: {
      cards: [
        {
          copy: 'pop_membership_daytime_stress_copy',
          image: {
            alt: 'pop_membership_daytime_stress_ui_alt',
            src: 'pop_membership_daytime_stress_ui_src',
          },
          title: 'pop_membership_daytime_stress_title',
        },
        {
          copy: 'pop_membership_resilience_copy',
          image: {
            alt: 'pop_membership_resilience_ui_alt',
            src: 'pop_membership_resilience_ui_src',
          },
          title: 'pop_membership_resilience_title',
        },
      ],
      featuredImage: {
        backgroundImage: {
          alt: 'pop_membership_stress_featured_img_alt',
          src: 'blue-sky/pop/stress_featured',
        },
      },
    },
  },
  {
    backgroundColor: 'red',
    Icon: HeartIcon as SVGIconComponent,
    id: 'heart_health',
    tab: {
      label: 'pop_membership_heart_health_tab_title',
    },
    tabPanel: {
      cards: [
        {
          copy: 'pop_membership_24-7_heart_rate_monitoring_copy',
          image: {
            alt: 'pop_membership_24-7_heart_rate_monitoring_ui_alt',
            src: 'pop_membership_24-7_heart_rate_monitoring_ui_src',
          },
          title: 'pop_membership_24-7_heart_rate_monitoring_title',
        },
        {
          copy: 'pop_membership_heart_rate_variability_copy',
          image: {
            alt: 'pop_membership_heart_rate_variability_ui_alt',
            src: 'pop_membership_heart_rate_variability_ui_src',
          },
          title: 'pop_membership_heart_rate_variability_title',
        },
      ],
      featuredImage: {
        backgroundImage: {
          alt: 'pop_membership_heart_health_featured_img_alt',
          src: 'blue-sky/pop/heart_health_featured',
        },
      },
    },
  },
  {
    backgroundColor: 'green',
    Icon: MeditationIcon as SVGIconComponent,
    id: 'womens_health',
    tab: {
      label: 'pop_membership_womens_health_tab_title',
    },
    tabPanel: {
      cards: [
        {
          copy: 'pop_membership_cycle_insights_copy',
          image: {
            alt: 'pop_membership_cycle_insights_ui_alt',
            src: 'pop_membership_cycle_insights_ui_src',
          },
          title: 'pop_membership_cycle_insights_title',
        },
        {
          copy: 'pop_membership_period_prediction_copy',
          image: {
            alt: 'pop_membership_period_prediction_ui_alt',
            src: 'pop_membership_period_prediction_ui_src',
          },
          title: 'pop_membership_period_prediction_title',
        },
        {
          copy: 'pop_membership_natural_cycles_integration_copy',
          image: {
            alt: 'pop_membership_natural_cycles_integration_ui_alt',
            src: 'pop_membership_natural_cycles_integration_ui_src',
          },
          title: 'pop_membership_natural_cycles_integration_title',
        },
        {
          copy: 'pop_membership_partner_integrations_copy',
          image: {
            alt: 'pop_membership_partner_integrations_ui_alt',
            src: 'pop_membership_partner_integrations_ui_src',
          },
          title: 'pop_membership_partner_integrations_title',
        },
      ],
      featuredImage: {
        backgroundImage: {
          alt: 'pop_membership_womens_health_featured_img_alt',
          src: 'blue-sky/pop/womens_health_featured',
        },
      },
    },
  },
];
